import { InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';

/**
 * Where preferences actually live. Values cross this seam untyped: the store serialises them and
 * maps the names onto its own fields, while the `SolSettingKey` each value belongs to is what says
 * how it narrows on the way back.
 */
export interface SolPreferenceStore {
  load(name: string): Observable<unknown>;

  save(name: string, value: unknown): Observable<void>;

  reset(name: string): Observable<void>;

  /**
   * The pre-paint answer: an absent name expresses no opinion, a `null` one was asked and had no answer.
   */
  prePaint(): Observable<Record<string, unknown>>;
}

/** Keeps preferences in memory only, for applications that provide no store. */
export class NoopSolPreferenceStore implements SolPreferenceStore {
  public load(): Observable<unknown> {
    return of(undefined);
  }

  public save(): Observable<void> {
    return of(undefined);
  }

  public reset(): Observable<void> {
    return of(undefined);
  }

  public prePaint(): Observable<Record<string, unknown>> {
    return of({});
  }
}

export const SOL_PREFERENCE_STORE = new InjectionToken<SolPreferenceStore>('sol-preference-store', {
  providedIn: 'root',
  factory: () => new NoopSolPreferenceStore(),
});
